import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import RoleOnly from "./role-only";
import IframeOnly from "./iframe-only";

const ReturnToPrescription = () => {
  const { t } = useTranslation();

  const handleClick = () => {
    window.parent.postMessage({ type: "close" }, "*");
  };

  return (
    <IframeOnly>
      <RoleOnly>
        <Button
          variant="accent"
          className="flex gap-1 items-center px-2 py-1 h-8"
          onClick={handleClick}
        >
          <span className="hidden md:block">{t("return_to_prescription")}</span>
        </Button>
      </RoleOnly>
    </IframeOnly>
  );
};

export default ReturnToPrescription;
